import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommitteeItemsService } from './committee-items.service';
import { CommitteeItemsComponent } from './committee-items.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  providers: [CommitteeItemsService],
  declarations: [CommitteeItemsComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    FormsModule,
    MatTableModule,
  ],
  exports: [CommitteeItemsComponent],
})
export class CommitteeItemsModule {}
